import React from 'react';
import { BsExclamationOctagon } from 'react-icons/bs';
import { GoDotFill } from 'react-icons/go';
import { STATUS_COLORS, withAlpha } from './calendar/CustomCalendar';

export function RenderEventContent(eventInfo: any) {
    const eventValues = eventInfo?.event?._def?.extendedProps;
    const hasNotifications = !!eventValues?.eventNotifications?.[0]?.isUnread;
    const { status, offerItem } = eventValues;
    const statusColor = STATUS_COLORS[status] || '#198754';
    const backgroundColor = withAlpha(statusColor, 0.15);
    const isProposed = status === 'proposed';
    const getCorrectIcon = (getStatus: string) => {
        if (getStatus === 'proposed') {
            return <BsExclamationOctagon className="proposed-icon" />;
        }
        return (
            <GoDotFill
                className="display-5"
                style={{
                    color: statusColor,
                    flexShrink: 0,
                }}
            />
        );
    };
    return (
        <div
            className="calendar-event-content"
            style={{
                borderLeft: `3px solid ${statusColor}`,
                background: backgroundColor,
            }}
        >
            <div className="event-info">
                {!!offerItem?.socialPlatform?.path && (
                    <div className="event-icon">
                        <img src={offerItem?.socialPlatform?.path} alt={offerItem?.socialPlatform?.name} />
                    </div>
                )}
                <span className="event-name">{offerItem?.offer?.campaign?.title}</span>
                {hasNotifications && <div className="notification-bullet-red calendar" />}
            </div>
        </div>
    );
}
